import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { CommonModule } from '@angular/common';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FormsModule } from '@angular/forms';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ImportadorService } from '../../services/importador.service';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';
import { EventService } from '../../services/event.service';
import moment from 'moment';
import 'moment/locale/es';

@Component({
  selector: 'app-modal-importar',
  standalone: true,
  imports: [CommonModule, BsDatepickerModule, FormsModule],
  templateUrl: './modal-importar.component.html',
  styleUrl: './modal-importar.component.scss'
})
export class ModalImportarComponent implements OnInit {

  fechaImportar: Date;
  fechaFormateada: string = '';
  fechaLegible: string = '';
  importando: boolean = false;
  requiereConfirmacion: boolean = false;
  mensajeConfirmacion: string = '';
  tipoImportacion: string = 'jornadas_y_viajes';

  constructor(
    private modalRef: BsModalRef,
    private importadorService: ImportadorService,
    private toastr: ToastrService,
    private eventService: EventService
  ) { }

  ngOnInit(): void {
    moment.locale('es');
    this.fechaImportar = moment().add(1, 'day').toDate();
    this.actualizarFechaLegible();
  }

  onChangeFecha(fecha: Date) {
    if (fecha) {
      this.fechaImportar = fecha;
      this.actualizarFechaLegible();
      this.requiereConfirmacion = false;
    }
  }

  actualizarFechaLegible() {
    this.fechaFormateada = moment(this.fechaImportar).format('DD-MM-YYYY');
    this.fechaLegible = moment(this.fechaImportar).format('dddd D [de] MMMM [de] YYYY');
    this.fechaLegible = this.fechaLegible.charAt(0).toUpperCase() + this.fechaLegible.slice(1);
  }

  ejecutar() {
    const fecha = moment(this.fechaImportar).format('YYYY-MM-DD');
    this.importando = true;

    this.importadorService.ejecutar(fecha, false, this.tipoImportacion).subscribe(
      (resp: any) => {
        this.importando = false;
        this.toastr.success(resp.msg || 'Importación ejecutada', 'Éxito', { timeOut: environment.toastSuccessTimeout, extendedTimeOut: environment.toastSuccessTimeout, closeButton: true, tapToDismiss: false });
        this.eventService.publish('IMPORTADOR_EJECUTADO');
        this.close();
      },
      (error: HttpErrorResponse) => {
        this.importando = false;
        if (error.status === 428) {
          this.requiereConfirmacion = true;
          this.mensajeConfirmacion = 'La fecha solicitada es hoy. Importar con la fecha de hoy puede generar duplicidad de viajes. ¿Desea continuar?';
        } else {
          this.toastr.error((error.error?.msg || 'Error al importar') + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
        }
      }
    );
  }

  confirmar() {
    const fecha = moment(this.fechaImportar).format('YYYY-MM-DD');
    this.importando = true;

    this.importadorService.ejecutar(fecha, true, this.tipoImportacion).subscribe(
      (resp: any) => {
        this.importando = false;
        this.toastr.success(resp.msg || 'Importación ejecutada', 'Éxito', { timeOut: environment.toastSuccessTimeout, extendedTimeOut: environment.toastSuccessTimeout, closeButton: true, tapToDismiss: false });
        this.eventService.publish('IMPORTADOR_EJECUTADO');
        this.close();
      },
      (error: HttpErrorResponse) => {
        this.importando = false;
        if (error?.status === 409) {
          this.toastr.warning((error.error?.msg || error.error?.details || 'Existe una importación en curso') + '. ' + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Alerta', { timeOut: environment.toastWarningTimeout, extendedTimeOut: environment.toastWarningTimeout, closeButton: true, tapToDismiss: false });
        } else {
          this.toastr.error((error.error?.msg || 'Error al importar') + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
        }
      }
    );
  }

  cancelarConfirmacion() {
    this.requiereConfirmacion = false;
  }

  close() {
    this.modalRef.hide();
  }
}
